<script>
  import { Tooltip } from "paxray-components-svelte";

  export let applicationTrend;
  export let hoveredTrendPoint = null;
  export let formatPlainNumber;
  export let formatDate;
  export let demo = false;
</script>

<section class="trend-card">
  <div class="card-heading">
    <div>
      <div class="heading-title"><strong>Application Count Trend</strong><Tooltip text={`Shows the application count from each transferred data update. ${demo ? "Hypothetical reduction over the last 24 months (Example)" : "Number of applications over transferred data updates"}.`} /></div>
    </div>
  </div>
  <div class="application-trend">
    {#if applicationTrend.points.length}
      <svg class="trend-chart" viewBox="0 0 480 130" preserveAspectRatio="none" aria-label="Application count trend" on:mouseleave={() => (hoveredTrendPoint = null)}>
        <defs>
          <linearGradient id="applicationTrendFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#ff5f1f" stop-opacity="0.24" />
            <stop offset="100%" stop-color="#ff5f1f" stop-opacity="0" />
          </linearGradient>
        </defs>
        <line class="grid-line" x1="0" y1="25" x2="480" y2="25" />
        <line class="grid-line" x1="0" y1="70" x2="480" y2="70" />
        <line class="grid-line" x1="0" y1="115" x2="480" y2="115" />
        {#if applicationTrend.area}<polyline class="trend-fill" points={applicationTrend.area} />{/if}
        <polyline class="trend-line" points={applicationTrend.line} />
        {#each applicationTrend.points as point}
          <circle class="trend-point" cx={point.x} cy={point.y} r="7" on:mouseenter={() => (hoveredTrendPoint = point)} />
        {/each}
      </svg>
      {#if hoveredTrendPoint}
        <div class="chart-tooltip" style={`left: ${hoveredTrendPoint.x / 480 * 100}%; top: ${hoveredTrendPoint.y / 130 * 100}%;`}>
          <strong>{formatPlainNumber(hoveredTrendPoint.value)} apps</strong>
          <span>{formatDate(hoveredTrendPoint.date)}</span>
        </div>
      {/if}
      <div class="trend-labels"><span>{applicationTrend.startLabel}</span><span>{applicationTrend.endLabel}</span></div>
    {:else}
      <div class="empty-state compact">No application trend available.</div>
    {/if}
  </div>
</section>

<style>
  .trend-card { position: relative; display: flex; width: 100%; min-width: 0; min-height: 0; box-sizing: border-box; overflow: hidden; flex-direction: column; border: 0; border-radius: 0.5rem; background: #fff; padding: 0 1rem 1rem; }
  .card-heading { display: flex; height: 4rem; min-height: 4rem; box-sizing: border-box; align-items: center; justify-content: space-between; gap: 1rem; border-bottom: 1px solid var(--border-color); }
  .card-heading > div { display: flex; min-width: 0; flex-direction: column; gap: 0.15rem; }
  .heading-title { display: flex !important; flex-direction: row !important; align-items: center; gap: 0.45rem; }
  .card-heading { box-sizing: border-box; margin-right: -1rem; margin-bottom: 1rem; margin-left: -1rem; padding-right: 1rem; padding-left: 1rem; }
  .card-heading strong { font-size: 0.875rem; }
  .application-trend { position: relative; display: flex; min-height: 0; flex: 1; flex-direction: column; margin-top: 0.5rem; }
  .trend-chart { width: 100%; height: 100%; min-height: 0; flex: 1 1 auto; overflow: visible; }
  .grid-line { stroke: #e5e7ea; stroke-dasharray: 3 4; stroke-width: 1px; vector-effect: non-scaling-stroke; }
  .trend-line { fill: none; stroke: var(--pax-black); stroke-linecap: round; stroke-linejoin: round; stroke-width: 1px; vector-effect: non-scaling-stroke; }
  .trend-fill { fill: url(#applicationTrendFill); stroke: none; }
  .trend-point { fill: transparent; stroke: transparent; cursor: pointer; }
  .chart-tooltip { position: absolute; z-index: 10; display: flex; min-width: 7rem; flex-direction: column; gap: 0.12rem; padding: 0.4rem 0.5rem; border-radius: 0.35rem; background: var(--pax-black); color: #fff; font-size: 0.68rem; line-height: 1.25; pointer-events: none; transform: translate(-50%, calc(-100% - 0.45rem)); }
  .chart-tooltip span { color: #d5d7da; font-size: 0.64rem; }
  .trend-labels { display: flex; justify-content: space-between; margin-top: 0.35rem; color: #8a929b; font-size: 0.68rem; }
  .empty-state { display: grid; min-height: 20rem; flex: 1; place-items: center; color: #6f7681; }
  .empty-state.compact { min-height: 8rem; }
</style>
